// Mock data for VALORAMAP - Emerging Markets Screener

export const markets = [
  { code: 'VN', name: 'Vietnam', exchange: 'Ho Chi Minh Stock Exchange', flag: '🇻🇳', gdpGrowth: '7.2%', stocks: 591 },
  { code: 'NSE', name: 'India', exchange: 'National Stock Exchange', flag: '🇮🇳', gdpGrowth: '7.3%', stocks: 2442 },
  { code: 'PSE', name: 'Philippines', exchange: 'Philippine Stock Exchange', flag: '🇵🇭', gdpGrowth: '5.4%', stocks: 257 },
  { code: 'JK', name: 'Indonesia', exchange: 'Indonesia Stock Exchange', flag: '🇮🇩', gdpGrowth: '5.3%', stocks: 943 },
  { code: 'WSE', name: 'Poland', exchange: 'Warsaw Stock Exchange', flag: '🇵🇱', gdpGrowth: '3.5%', stocks: 587 },
  { code: 'KRX', name: 'South Korea', exchange: 'Korea Exchange', flag: '🇰🇷', gdpGrowth: '2.1%', stocks: 1478 }
];

export const sectors = [
  { value: 'Technology', label: 'Technologie' },
  { value: 'Finance', label: 'Finance' },
  { value: 'Financial Services', label: 'Services Financiers' },
  { value: 'Healthcare', label: 'Santé' },
  { value: 'Consumer Goods', label: 'Biens de Consommation' },
  { value: 'Consumer Cyclical', label: 'Consommation Cyclique' },
  { value: 'Consumer Defensive', label: 'Consommation Défensive' },
  { value: 'Industrial', label: 'Industrie' },
  { value: 'Industrials', label: 'Industrie' },
  { value: 'Energy', label: 'Énergie' },
  { value: 'Real Estate', label: 'Immobilier' },
  { value: 'Materials', label: 'Matériaux' },
  { value: 'Basic Materials', label: 'Matières Premières' },
  { value: 'Utilities', label: 'Services Publics' },
  { value: 'Telecommunications', label: 'Télécommunications' },
  { value: 'Communication Services', label: 'Services de Communication' }
];

export const mockStocks = [
  // Vietnam stocks
  { symbol: 'VNM', name: 'Vinamilk', market: 'VN', price: 74500, currency: 'VND', pe: 14.2, pb: 3.8, roe: 26.8, marketCap: 155000, sector: 'Consumer Goods', change: 2.3, volume: 1250000 },
  { symbol: 'VIC', name: 'Vingroup', market: 'VN', price: 42100, currency: 'VND', pe: 18.5, pb: 1.2, roe: 6.5, marketCap: 145000, sector: 'Real Estate', change: -1.2, volume: 890000 },
  { symbol: 'FPT', name: 'FPT Corporation', market: 'VN', price: 125400, currency: 'VND', pe: 22.1, pb: 4.5, roe: 20.4, marketCap: 128000, sector: 'Technology', change: 3.8, volume: 2100000 },
  { symbol: 'HPG', name: 'Hoa Phat Group', market: 'VN', price: 25800, currency: 'VND', pe: 8.9, pb: 1.1, roe: 12.3, marketCap: 115000, sector: 'Materials', change: 0.8, volume: 5600000 },
  { symbol: 'MWG', name: 'Mobile World', market: 'VN', price: 52300, currency: 'VND', pe: 12.4, pb: 2.8, roe: 22.6, marketCap: 76000, sector: 'Consumer Goods', change: 1.5, volume: 1890000 },
  { symbol: 'TCB', name: 'Techcombank', market: 'VN', price: 48200, currency: 'VND', pe: 7.8, pb: 1.5, roe: 19.2, marketCap: 168000, sector: 'Finance', change: 2.1, volume: 3200000 },
  { symbol: 'VHM', name: 'Vinhomes', market: 'VN', price: 39500, currency: 'VND', pe: 9.2, pb: 1.8, roe: 19.6, marketCap: 172000, sector: 'Real Estate', change: -0.5, volume: 1450000 },
  
  // India stocks
  { symbol: 'TCS', name: 'Tata Consultancy', market: 'NSE', price: 4125, currency: 'INR', pe: 28.5, pb: 12.8, roe: 44.9, marketCap: 15200000, sector: 'Technology', change: 1.2, volume: 2340000 },
  { symbol: 'INFY', name: 'Infosys Limited', market: 'NSE', price: 1876, currency: 'INR', pe: 24.3, pb: 8.2, roe: 33.7, marketCap: 7800000, sector: 'Technology', change: 0.9, volume: 4560000 },
  { symbol: 'HDFCBANK', name: 'HDFC Bank', market: 'NSE', price: 1745, currency: 'INR', pe: 18.9, pb: 2.6, roe: 13.7, marketCap: 13200000, sector: 'Finance', change: -0.3, volume: 8900000 },
  { symbol: 'RELIANCE', name: 'Reliance Industries', market: 'NSE', price: 2890, currency: 'INR', pe: 26.1, pb: 2.1, roe: 8.1, marketCap: 19500000, sector: 'Energy', change: 1.8, volume: 12300000 },
  { symbol: 'ICICIBANK', name: 'ICICI Bank', market: 'NSE', price: 1285, currency: 'INR', pe: 17.2, pb: 3.1, roe: 18.0, marketCap: 8900000, sector: 'Finance', change: 0.5, volume: 15600000 },
  { symbol: 'SUNPHARMA', name: 'Sun Pharmaceutical', market: 'NSE', price: 1542, currency: 'INR', pe: 32.4, pb: 4.8, roe: 14.8, marketCap: 3700000, sector: 'Healthcare', change: 2.4, volume: 3200000 },
  { symbol: 'WIPRO', name: 'Wipro Limited', market: 'NSE', price: 298, currency: 'INR', pe: 18.6, pb: 3.2, roe: 17.2, marketCap: 3100000, sector: 'Technology', change: -1.1, volume: 7800000 },
  
  // Philippines stocks
  { symbol: 'SM', name: 'SM Investments', market: 'PSE', price: 925, currency: 'PHP', pe: 16.8, pb: 2.1, roe: 12.5, marketCap: 1120000, sector: 'Finance', change: 0.6, volume: 450000 },
  { symbol: 'BDO', name: 'BDO Unibank', market: 'PSE', price: 148, currency: 'PHP', pe: 9.2, pb: 1.4, roe: 15.2, marketCap: 650000, sector: 'Finance', change: 1.3, volume: 890000 },
  { symbol: 'ALI', name: 'Ayala Land', market: 'PSE', price: 32.5, currency: 'PHP', pe: 12.4, pb: 1.6, roe: 12.9, marketCap: 480000, sector: 'Real Estate', change: -0.8, volume: 1230000 },
  { symbol: 'JFC', name: 'Jollibee Foods', market: 'PSE', price: 248, currency: 'PHP', pe: 35.2, pb: 4.2, roe: 11.9, marketCap: 270000, sector: 'Consumer Goods', change: 2.1, volume: 340000 },
  
  // Indonesia stocks
  { symbol: 'BBCA', name: 'Bank Central Asia', market: 'JK', price: 9875, currency: 'IDR', pe: 22.4, pb: 4.5, roe: 20.1, marketCap: 1215000000, sector: 'Finance', change: 1.5, volume: 12500000 },
  { symbol: 'TLKM', name: 'Telkom Indonesia', market: 'JK', price: 3420, currency: 'IDR', pe: 14.8, pb: 2.8, roe: 18.9, marketCap: 338000000, sector: 'Telecommunications', change: 0.3, volume: 45000000 },
  { symbol: 'ASII', name: 'Astra International', market: 'JK', price: 4850, currency: 'IDR', pe: 6.2, pb: 1.1, roe: 17.7, marketCap: 196000000, sector: 'Industrial', change: -0.4, volume: 23000000 },
  { symbol: 'UNVR', name: 'Unilever Indonesia', market: 'JK', price: 3250, currency: 'IDR', pe: 28.6, pb: 32.1, roe: 112.2, marketCap: 124000000, sector: 'Consumer Goods', change: 0.9, volume: 8900000 },
  
  // Poland stocks
  { symbol: 'PKO', name: 'PKO Bank Polski', market: 'WSE', price: 58.2, currency: 'PLN', pe: 7.8, pb: 1.2, roe: 15.4, marketCap: 72800, sector: 'Finance', change: 1.8, volume: 2340000 },
  { symbol: 'PKN', name: 'PKN Orlen', market: 'WSE', price: 52.8, currency: 'PLN', pe: 4.2, pb: 0.6, roe: 14.3, marketCap: 45200, sector: 'Energy', change: -2.1, volume: 3450000 },
  { symbol: 'CDR', name: 'CD Projekt', market: 'WSE', price: 142.5, currency: 'PLN', pe: 18.9, pb: 2.8, roe: 14.8, marketCap: 14200, sector: 'Technology', change: 3.2, volume: 890000 },
  { symbol: 'PZU', name: 'PZU SA', market: 'WSE', price: 48.6, currency: 'PLN', pe: 8.4, pb: 1.5, roe: 17.9, marketCap: 42000, sector: 'Finance', change: 0.5, volume: 1560000 },
  
  // South Korea stocks
  { symbol: '005930', name: 'Samsung Electronics', market: 'KRX', price: 72400, currency: 'KRW', pe: 12.8, pb: 1.2, roe: 9.4, marketCap: 432000000, sector: 'Technology', change: 1.4, volume: 15600000 },
  { symbol: '000660', name: 'SK Hynix', market: 'KRX', price: 178500, currency: 'KRW', pe: 8.2, pb: 1.8, roe: 22.0, marketCap: 130000000, sector: 'Technology', change: 2.8, volume: 4500000 },
  { symbol: '035420', name: 'Naver Corp', market: 'KRX', price: 215000, currency: 'KRW', pe: 32.4, pb: 1.6, roe: 4.9, marketCap: 35200000, sector: 'Technology', change: -0.6, volume: 890000 },
  { symbol: '051910', name: 'LG Chem', market: 'KRX', price: 298000, currency: 'KRW', pe: 45.2, pb: 1.4, roe: 3.1, marketCap: 21000000, sector: 'Materials', change: 1.2, volume: 340000 },
  { symbol: '105560', name: 'KB Financial', market: 'KRX', price: 82400, currency: 'KRW', pe: 6.8, pb: 0.6, roe: 8.8, marketCap: 34200000, sector: 'Finance', change: 0.9, volume: 1230000 }
];

export const pricingPlans = [
  {
    id: 'trial',
    name: 'Essai',
    price: 9,
    period: '7 jours',
    currency: 'CHF',
    description: 'Testez toutes les fonctionnalités',
    features: [
      'Accès complet au screener',
      '6 marchés émergents',
      '6 200+ actions',
      'Export CSV illimité',
      'Alertes prix',
      'Guides investissement EM'
    ],
    cta: 'Commencer l\'essai',
    popular: false
  },
  {
    id: 'premium',
    name: 'Premium',
    price: 399,
    period: 'par an',
    currency: 'CHF',
    description: 'Pour les investisseurs sérieux',
    features: [
      'Tout de l\'Essai +',
      '10 watchlists personnalisées',
      'Alertes earnings & dividendes',
      'Newsletter hebdomadaire',
      'Support email prioritaire',
      'Futures features incluses'
    ],
    cta: 'Choisir Premium',
    popular: true
  },
  {
    id: 'founding',
    name: 'Founding Member',
    price: 279,
    period: 'par an à vie',
    currency: 'CHF',
    description: 'Prix verrouillé pour toujours',
    features: [
      'Tout de Premium +',
      'Prix 279 CHF/an garanti à vie',
      'Badge Founding Member',
      'Accès beta features',
      'AMA privés mensuels',
      'Vote priorités roadmap'
    ],
    cta: 'Rejoindre les Founders',
    popular: false,
    limited: true,
    remaining: 47
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Jean-Pierre M.',
    role: 'Investisseur value, Paris',
    avatar: 'JP',
    content: 'Enfin un screener qui me donne accès aux small-caps vietnamiennes. J\'ai trouvé 3 pépites à P/E < 10 avec ROE > 20%. Introuvable ailleurs en français.',
    rating: 5
  },
  {
    id: 2,
    name: 'Marie D.',
    role: 'Gérante de patrimoine, Genève',
    avatar: 'MD',
    content: 'Mes clients demandaient une diversification EM depuis des années. VALORAMAP me permet de leur proposer des analyses fondamentales solides sur l\'Inde et l\'ASEAN.',
    rating: 5
  },
  {
    id: 3,
    name: 'Thomas L.',
    role: 'Analyste financier, Bruxelles',
    avatar: 'TL',
    content: 'L\'upgrade Vietnam FTSE de septembre 2026 va créer des opportunités énormes. Je suis positionné depuis 6 mois grâce aux alertes d\'VALORAMAP.',
    rating: 5
  }
];

export const features = [
  {
    title: 'Screener Value Avancé',
    description: 'Filtrez parmi 6 200+ actions avec 50+ critères fondamentaux : P/E, P/B, ROE, Debt/Equity, FCF Yield et plus.',
    icon: 'Filter'
  },
  {
    title: '6 Marchés Émergents',
    description: 'Vietnam, Inde, Philippines, Indonésie, Pologne, Corée du Sud - les économies à 5-10% de croissance annuelle.',
    icon: 'Globe'
  },
  {
    title: 'Données Institutionnelles',
    description: 'Données de qualité professionnelle utilisées par les investisseurs institutionnels. Mise à jour quotidienne automatique.',
    icon: 'Database'
  },
  {
    title: 'Alertes Intelligentes',
    description: 'Notifications prix, earnings, dividendes. Ne manquez plus jamais une opportunité d\'achat.',
    icon: 'Bell'
  },
  {
    title: 'Watchlists Illimitées',
    description: 'Organisez vos opportunités par marché, secteur ou stratégie. Partagez avec la communauté.',
    icon: 'Star'
  },
  {
    title: 'Export & Analyses',
    description: 'Export CSV illimité. Intégration avec vos outils. Guides détaillés par marché.',
    icon: 'Download'
  }
];

export const stats = [
  { value: '6 200+', label: 'Actions couvertes' },
  { value: '6', label: 'Marchés émergents' },
  { value: '6,4%', label: 'Croissance GDP moyenne' },
  { value: '50+', label: 'Critères de filtrage' }
];

// Format currency based on market
export const formatCurrency = (value, currency) => {
  const formatters = {
    VND: new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND', maximumFractionDigits: 0 }),
    INR: new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }),
    PHP: new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }),
    IDR: new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }),
    PLN: new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }),
    KRW: new Intl.NumberFormat('ko-KR', { style: 'currency', currency: 'KRW', maximumFractionDigits: 0 }),
    EUR: new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' })
  };
  return formatters[currency]?.format(value) || value;
};

// Format market cap
export const formatMarketCap = (value, currency) => {
  if (value == null || isNaN(value) || value === 0) return 'N/A';
  // Value is in raw units (e.g., 1189661112270848)
  if (value >= 1e12) return `${(value / 1e12).toFixed(1)}T`;
  if (value >= 1e9) return `${(value / 1e9).toFixed(1)}B`;
  if (value >= 1e6) return `${(value / 1e6).toFixed(1)}M`;
  if (value >= 1e3) return `${(value / 1e3).toFixed(1)}K`;
  return `${value}`;
};
